// import { useEffect, useState } from "react";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import { BASE_URL } from "./baseUrl";
// import { FiPlus, FiX } from "react-icons/fi";

// const defaultForm = {
//   name: "",
//   email: "",
//   password: "",
//   region: "global",
// };

// function AdminUsers() {
//   const [admins, setAdmins] = useState([]);
//   const [formData, setFormData] = useState(defaultForm);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     fetchAdmins();
//   }, []);

//   const fetchAdmins = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.get(`${BASE_URL}/admin/list`, {
//         headers: { authorization: `Bearer ${token}` },
//       });
//       setAdmins(res.data.admins || []);
//     } catch (error) {
//       toast.error(error?.response?.data?.error || "Failed to load admins", {
//         containerId: "admins",
//       });
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       if (!formData.name.trim()) {
//         toast.error("Please enter name", { containerId: "admins" });
//         return;
//       }
//       if (!formData.email.trim()) {
//         toast.error("Please enter email", { containerId: "admins" });
//         return;
//       }
//       if (!formData.password.trim()) {
//         toast.error("Please enter password", { containerId: "admins" });
//         return;
//       }

//       const token = localStorage.getItem("token");
//       const res = await axios.post(`${BASE_URL}/admin/register`, formData, {
//         headers: { authorization: `Bearer ${token}` },
//       });

//       toast.success(res.data.message || "Admin created successfully", {
//         containerId: "admins",
//       });

//       setFormData(defaultForm);
//       setIsModalOpen(false);
//       fetchAdmins();
//     } catch (error) {
//       toast.error(error?.response?.data?.error || "Failed to create admin", {
//         containerId: "admins",
//       });
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-8">
//       <ToastContainer containerId="admins" />
//       <div className="max-w-5xl mx-auto">
//         <div className="flex justify-between items-center mb-8">
//           <h1 className="text-3xl font-bold">Admin Users</h1>
//           <button
//             onClick={() => setIsModalOpen(true)}
//             className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
//           >
//             <FiPlus /> Add Admin
//           </button>
//         </div>

//         <div className="bg-white rounded-xl shadow p-6">
//           {admins.length === 0 ? (
//             <p className="text-gray-500">No admin users found.</p>
//           ) : (
//             <div className="space-y-4">
//               {admins.map((admin) => (
//                 <div key={admin._id} className="border rounded-lg p-4">
//                   <h3 className="font-bold text-lg">{admin.name || "Admin"}</h3>
//                   <p className="text-gray-700">{admin.email}</p>
//                   <p className="text-sm text-gray-500">Region: {admin.region || "global"}</p>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {isModalOpen && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
//             <div className="bg-white rounded-lg p-6 w-96">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-bold">Add Admin</h2>
//                 <button onClick={() => setIsModalOpen(false)} className="text-gray-500">
//                   <FiX size={24} />
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <input
//                   type="text"
//                   placeholder="Full name"
//                   value={formData.name}
//                   onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                   className="w-full p-3 border rounded-lg"
//                 />
//                 <input
//                   type="email"
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                   className="w-full p-3 border rounded-lg"
//                 />
//                 <input
//                   type="password"
//                   placeholder="Temporary password"
//                   value={formData.password}
//                   onChange={(e) => setFormData({ ...formData, password: e.target.value })}
//                   className="w-full p-3 border rounded-lg"
//                 />
//                 <input
//                   type="text"
//                   placeholder="Region"
//                   value={formData.region}
//                   onChange={(e) => setFormData({ ...formData, region: e.target.value })}
//                   className="w-full p-3 border rounded-lg"
//                 />

//                 <div className="flex justify-end gap-4">
//                   <button
//                     onClick={() => setIsModalOpen(false)}
//                     className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleSubmit}
//                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     Create Admin
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default AdminUsers;

import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { BASE_URL } from "./baseUrl";
import {
  FiPlus,
  FiX,
  FiUsers,
  FiShield,
  FiGlobe,
  FiMail,
} from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";

const defaultForm = {
  name: "",
  email: "",
  password: "",
  region: "global",
};

function AdminUsers() {
  const [admins, setAdmins] = useState([]);
  const [formData, setFormData] = useState(defaultForm);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/admin/list`, {
        headers: { authorization: `Bearer ${token}` },
      });
      setAdmins(res.data.admins || []);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to load admins", {
        containerId: "admins",
      });
    }
  };

  const handleSubmit = async () => {
    try {
      if (!formData.name.trim()) {
        toast.error("Please enter name", { containerId: "admins" });
        return;
      }
      if (!formData.email.trim()) {
        toast.error("Please enter email", { containerId: "admins" });
        return;
      }
      if (!formData.password.trim()) {
        toast.error("Please enter password", { containerId: "admins" });
        return;
      }

      const token = localStorage.getItem("token");
      const res = await axios.post(`${BASE_URL}/admin/register`, formData, {
        headers: { authorization: `Bearer ${token}` },
      });

      toast.success(res.data.message || "Admin created successfully", {
        containerId: "admins",
      });

      setFormData(defaultForm);
      setIsModalOpen(false);
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to create admin", {
        containerId: "admins",
      });
    }
  };

  const stats = useMemo(
    () => ({
      total: admins.length,
      global: admins.filter(
        (admin) => (admin.region || "global").toLowerCase() === "global"
      ).length,
      other: admins.filter(
        (admin) => (admin.region || "global").toLowerCase() !== "global"
      ).length,
    }),
    [admins]
  );

  return (
    <div className="space-y-8">
      <ToastContainer containerId="admins" position="top-right" autoClose={2500} />

      <section className="rounded-[32px] border border-white/10 bg-white/5 p-6 shadow-xl shadow-black/10 backdrop-blur-sm lg:p-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="inline-flex rounded-full border border-violet-400/20 bg-violet-400/10 px-4 py-2 text-sm font-medium text-violet-200">
              Platform access control
            </div>

            <h1 className="mt-4 text-3xl font-semibold tracking-tight text-white lg:text-4xl">
              Admin Users
            </h1>

            <p className="mt-3 max-w-2xl text-slate-300">
              Manage platform administrators with super admin access across the
              E-Lex control plane.
            </p>
          </div>

          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-violet-500 via-fuchsia-500 to-indigo-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-violet-900/30 transition hover:scale-[1.01]"
          >
            <FiPlus />
            Add Admin
          </button>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-3">
          <div className="rounded-3xl border border-white/10 bg-slate-950/40 p-5">
            <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500/20 to-fuchsia-500/20 text-violet-200">
              <FiUsers className="text-lg" />
            </div>
            <div className="mt-4 text-sm text-slate-400">Total admins</div>
            <div className="mt-1 text-2xl font-semibold text-white">
              {stats.total}
            </div>
          </div>

          <div className="rounded-3xl border border-white/10 bg-slate-950/40 p-5">
            <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500/20 to-teal-500/20 text-emerald-200">
              <FiShield className="text-lg" />
            </div>
            <div className="mt-4 text-sm text-slate-400">Global admins</div>
            <div className="mt-1 text-2xl font-semibold text-white">
              {stats.global}
            </div>
          </div>

          <div className="rounded-3xl border border-white/10 bg-slate-950/40 p-5">
            <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500/20 to-cyan-500/20 text-sky-200">
              <FiGlobe className="text-lg" />
            </div>
            <div className="mt-4 text-sm text-slate-400">Regional admins</div>
            <div className="mt-1 text-2xl font-semibold text-white">
              {stats.other}
            </div>
          </div>
        </div>
      </section>

      <section className="rounded-[32px] border border-white/10 bg-white/5 p-6 shadow-xl shadow-black/10 backdrop-blur-sm">
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <h2 className="text-2xl font-semibold text-white">
              Current admin users
            </h2>
            <p className="mt-1 text-sm text-slate-400">
              Review platform-level access and admin coverage.
            </p>
          </div>

          <div className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-slate-300">
            {admins.length} active
          </div>
        </div>

        {admins.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-white/10 bg-slate-950/30 p-8 text-center text-slate-400">
            No admin users found.
          </div>
        ) : (
          <div className="grid gap-4 lg:grid-cols-2">
            {admins.map((admin) => (
              <div
                key={admin._id}
                className="rounded-3xl border border-white/10 bg-slate-950/40 p-5"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="text-xl font-semibold text-white">
                      {admin.name || "Admin"}
                    </h3>
                    <div className="mt-2 flex items-center gap-2 text-sm text-slate-300">
                      <FiMail />
                      {admin.email}
                    </div>
                  </div>

                  <span className="rounded-full border border-violet-400/20 bg-violet-500/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-violet-200">
                    Super Admin
                  </span>
                </div>

                <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
                  <div className="flex items-center gap-2 text-sm text-slate-400">
                    <FiGlobe />
                    Region
                  </div>
                  <div className="mt-2 text-sm font-medium text-slate-200">
                    {admin.region || "global"}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/75 p-4 backdrop-blur-sm">
          <div className="w-full max-w-xl rounded-[32px] border border-white/10 bg-slate-900/95 p-6 shadow-2xl shadow-black/40">
            <div className="mb-6 flex items-start justify-between gap-4">
              <div>
                <div className="inline-flex rounded-full border border-violet-400/20 bg-violet-400/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-violet-200">
                  Add Admin
                </div>
                <h2 className="mt-3 text-2xl font-semibold text-white">
                  Create platform admin
                </h2>
              </div>

              <button
                onClick={() => setIsModalOpen(false)}
                className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-slate-300 transition hover:bg-white/10 hover:text-white"
              >
                <FiX />
              </button>
            </div>

            <div className="grid gap-4">
              <input
                type="text"
                placeholder="Full name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none placeholder:text-slate-500 focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
              />
              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none placeholder:text-slate-500 focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
              />
              <input
                type="password"
                placeholder="Temporary password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none placeholder:text-slate-500 focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
              />
              <input
                type="text"
                placeholder="Region"
                value={formData.region}
                onChange={(e) =>
                  setFormData({ ...formData, region: e.target.value })
                }
                className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none placeholder:text-slate-500 focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
              />
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setIsModalOpen(false)}
                className="rounded-2xl border border-white/10 bg-white/5 px-5 py-3 text-sm font-medium text-slate-200 transition hover:bg-white/10"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="rounded-2xl bg-gradient-to-r from-violet-500 via-fuchsia-500 to-indigo-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-violet-900/30 transition hover:scale-[1.01]"
              >
                Create Admin
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminUsers;